<template>
	<div>
		<img v-if="isSafari || isFacebookApp" :src="gifSource" :width="modelSize.w" :height="modelSize.h">
		<video v-else :width="modelSize.w" :height="modelSize.h" loop autoplay muted playsinline :src="videoSource">
			<source :src="videoSource" type="video/mov">
		</video>
	</div>
</template>

<script>
	export default {
		name: "ModelViewer",
		data: () => ({
			videoSource: require('../assets/video/hisa.webm'),
			gifSource: require('../assets/video/hisa.gif'),
		}),
		created() {
			const vm = this;


		},
		mounted() {
			const vm = this;

			vm.$emit('loaded');
		},
		computed: {
			modelSize() {
				const vm = this;
				switch (this.$vuetify.breakpoint.name) {
					case 'xs':
					case 'sm':
						return {
							w: 340,
							h: 'auto'
						};
						break;
					case 'md':
						return {
							w: 500,
							h: 'auto'
						};
						break;
					case 'lg':
					case 'xl':
					default:
						return {
							w: 850,
							h: 'auto'
						};
						break;
				}
			},
			isSafari() {
				return navigator.userAgent.search('Safari') >= 0 && navigator.userAgent.search('Chrome') < 0;
			},
			isFacebookApp() {
				var ua = navigator.userAgent || navigator.vendor || window.opera;
				return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
			}
		},
		methods: {
			onLoad() {
				this.$emit('loaded');
			}
		}
	}
</script>

<style scoped>

</style>
